module.exports = __webpack_public_path__ + "img/SummaryBanner.bb7af81b.svg";